import * as Rx from 'rxjs';
import * as RxOp from 'rxjs/operators';

export const DPS_VOID_POLLING_INTERVAL_MS = 2000;
export const DPS_VOID_POLLING_TIMEOUT_MS = 60000;

/**
 * Creates a polling observable for DPS void workflows.
 *
 * @param {Object} options
 * @param {Function} options.pollFn - Returns an Observable for each poll tick.
 * @param {Function} options.isDone - (pollResponse) => boolean. Returns true when polling should stop (terminal state reached), regardless of outcome.
 * @param {Function} options.onSuccess - (pollResponse) => Observable of actions to emit on resolution.
 * @param {Function} options.onTimeout - () => Observable of actions to emit on timeout.
 * @param {Function} options.onError - (error) => Observable of actions to emit on poll error.
 * @param {Observable} options.stopSignal$ - Observable that terminates the polling loop (e.g. action$.ofType(STOP_*)).
 * @returns {Observable} A polling observable.
 */
export const createDpsVoidPolling = ({
  pollFn,
  isDone,
  onSuccess,
  onTimeout,
  onError,
  stopSignal$,
}) =>
  Rx.timer(0, DPS_VOID_POLLING_INTERVAL_MS).pipe(
    RxOp.scan((_acc, _val, index) => index * DPS_VOID_POLLING_INTERVAL_MS, 0),
    RxOp.takeWhile((elapsed) => elapsed < DPS_VOID_POLLING_TIMEOUT_MS, true),
    RxOp.exhaustMap((elapsedTime) => {
      if (elapsedTime >= DPS_VOID_POLLING_TIMEOUT_MS) {
        return onTimeout();
      }
      return pollFn().pipe(
        RxOp.flatMap((pollResponse) => {
          if (isDone(pollResponse)) {
            return onSuccess(pollResponse);
          }
          return Rx.EMPTY;
        }),
        RxOp.catchError((err) => onError(err)),
      );
    }),
    RxOp.takeUntil(stopSignal$),
  );
